export default [
  {
    title: "Meet Our Team",
    desc: "We are led by a group of highly motivated people with diverse backgrounds and extensive experience to unlock creativity around every corner.",
  },
  {
    title: "Tim Kami",
    desc: "Sekelompok profesional yang bermotivasi tinggi dengan latar belakang yang beragam, pengalaman luas, minat khusus, dan rekam jejak kesuksesan. Perbedaan inilah yang saling melengkapi keterampilan yang kami miliki.",
  },
];
